import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: 'Project Manager',
  careerLink: 'Back to career'
})
